/* eslint-disable no-useless-escape */
import { CircularProgress } from '@mui/material'
import {
	BarMultiSelect,
	Button,
	DateTimer,
	DropdownFull,
	Helper,
	InputRadio,
	RadioGroups,
	Typography
} from 'components'
import { useToast } from 'hooks'
import { useSchedule } from 'hooks/useSchedule'
import {
	Icons,
	ScheduleFormInputs,
	ScheduleProps,
	TypographyTypes
} from 'interfaces'
import {
	ItemRadios,
	daysTypeData,
	endShedules,
	itemSchedule,
	itemScheduleEdit,
	itemScheduleEvent,
	periodTypeData
} from 'lib'
import { listDays } from 'lib/dataBarMultiSelect'
import debounce from 'lodash/debounce'
import dayjs from 'lib/dayjs'
import type { Dayjs } from 'dayjs'
import React, { SetStateAction, useCallback, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

export const Schedule: React.FC<ScheduleProps> = ({
	totalData,
	setTotalData,
	onClickClose,
	setOpenSlide,
	deliveryActive,
	itemRecurrence,
	eventRecurrence,
	setDeliveryActive,
	setItemRecurrence,
	itemDatePushNotofication,
	setItemDatePushNotofication,
	mode,
	isLoading,
	setEventRecurrence,
	isExpiratedView = false,
	locationComponent = 'Content Item'
}): JSX.Element => {
	const { showToast } = useToast()
	const [isSubmit, setIsSubmit] = useState(false)
	const [edit, setEdit] = useState(0)
	const [eventDateResetKey, setEventDateResetKey] = useState(0)
	const [publisDate, setPublisDate] = useState<string | Dayjs>('')
	const [dataCurrency, setDataCurrency] = useState<string | Dayjs>('')
	const [publisDateEvent, setPublisDateEvent] = useState<string | Dayjs>('')
	const [expirationDateEvent, setExpirationDateEvent] = useState<
		string | Dayjs
	>('')
	const [untilDateEvent, setUntilDateEvent] = useState<string | Dayjs>('')
	const [expirationDate, setExpirationDate] = useState<string | Dayjs>('')
	const [endRadio, setEndRadio] = useState({
		id: '1',
		title: 'Never',
		value: 'never'
	})
	const [endDate, setEndDate] = useState<string | Dayjs>('')
	const [endDateType, setEndDateType] = useState(daysTypeData[0])
	const [dateType, setDateType] = useState(daysTypeData[0])
	const [periodType, setPeriodType] = useState(periodTypeData[0])
	const [listDaysSeleted, setListDaysSeleted] = useState<string[]>([])
	const [itemSelected, setItemSelected] = useState<ItemRadios[]>([])
	// Pendiente revicion con cliente
	// const [dataCurrencyEvent, setDataCurrencyEvent] = useState<string | Dayjs>(
	// 	''
	// )
	// const [endRadioEvent, setEndRadioEvent] = useState({
	// 	id: '1',
	// 	title: 'Never',
	// 	value: 'never'
	// })
	// const [dateTypeEvent, setDateTypeEvent] = useState(daysTypeData[0])
	// const [endDateEvent, setEndDateEvent] = useState<string | Dayjs>('')
	// const [endDdateTypeEvent, setEndDateTypeEvent] = useState(daysTypeData[0])
	// const [periodTypeEvent, setPeriodTypeEvent] = useState(periodTypeData[0])
	// const [listDaysSeletedEvent, setListDaysSeletedEvent] = useState<string[]>([])

	const { handleSubmit } = useForm<ScheduleFormInputs>({
		mode: 'all'
	})

	const showToastDebounced = useCallback(
		debounce(
			(
				title: string,
				message: string,
				type: 'error' | 'success' | 'warning'
			) => {
				showToast(title, message, type)
			},
			4000
		),
		[]
	)

	const {
		isValidFutureDate,
		isValidExpirationDate,
		isValidEventEndDate,
		isValidEndDateVsDataCurrency,
		handleChangeDataCurrency,
		handleChangeEndDate,
		isValidUntilDate,
		handleChangeSchedule,
		handleChangeExpirationDate,
		handleChangeUntilDateEvent
	} = useSchedule({
		showToastDebounced,
		setDataCurrency,
		endDate,
		setEndDate,
		endRadio,
		dataCurrency,
		setPublisDate,
		expirationDate,
		setExpirationDate,
		publisDate,
		expirationDateEvent,
		setUntilDateEvent
	})

	const isValidRecurrence = (): boolean => {
		if (itemRecurrence !== '2') return true

		return !!(
			dateType?.id &&
			periodType?.value &&
			(endRadio.value !== 'after_ocurrence' || endDateType?.id)
		)
	}

	useEffect(() => {
		if (totalData.basic_setup.category === 'event') {
			if (itemRecurrence === '1' && eventRecurrence === '1') {
				if (
					publisDate === '' ||
					!isValidFutureDate(publisDate) ||
					publisDateEvent === '' ||
					!isValidFutureDate(publisDateEvent) ||
					expirationDateEvent === '' ||
					!isValidFutureDate(expirationDateEvent) ||
					!isValidEventEndDate(publisDateEvent, expirationDateEvent) ||
					dayjs(publisDateEvent as Dayjs).isBefore(
						dayjs(publisDate as Dayjs),
						'minute'
					) ||
					(isExpiratedView &&
						(expirationDate === '' ||
							!isValidFutureDate(expirationDate) ||
							!isValidExpirationDate(publisDate, expirationDate) ||
							dayjs(expirationDateEvent as Dayjs).isAfter(
								dayjs(expirationDate as Dayjs),
								'minute'
							) ||
							dayjs(publisDateEvent as Dayjs).isAfter(
								dayjs(expirationDate as Dayjs),
								'minute'
							)))
				) {
					setIsSubmit(false)
				} else {
					setIsSubmit(true)
				}
			} else if (itemRecurrence === '1' && eventRecurrence === '2') {
				if (
					publisDate === '' ||
					!isValidFutureDate(publisDate) ||
					publisDateEvent === '' ||
					!isValidFutureDate(publisDateEvent) ||
					expirationDateEvent === '' ||
					!isValidFutureDate(expirationDateEvent) ||
					!isValidEventEndDate(publisDateEvent, expirationDateEvent) ||
					dayjs(publisDateEvent as Dayjs).isBefore(
						dayjs(publisDate as Dayjs),
						'minute'
					) ||
					untilDateEvent === '' ||
					!isValidFutureDate(untilDateEvent) ||
					!isValidUntilDate(expirationDateEvent, untilDateEvent) ||
					(isExpiratedView &&
						(expirationDate === '' ||
							!isValidFutureDate(expirationDate) ||
							!isValidExpirationDate(publisDate, expirationDate) ||
							dayjs(expirationDateEvent as Dayjs).isAfter(
								dayjs(expirationDate as Dayjs),
								'minute'
							) ||
							dayjs(publisDateEvent as Dayjs).isAfter(
								dayjs(expirationDate as Dayjs),
								'minute'
							)))
				) {
					setIsSubmit(false)
				} else {
					setIsSubmit(true)
				}
			} else if (itemRecurrence === '2' && eventRecurrence === '1') {
				if (periodType.value === 'week') {
					if (
						!isValidRecurrence() ||
						listDaysSeleted.length === 0 ||
						dataCurrency === '' ||
						!isValidFutureDate(dataCurrency) ||
						publisDateEvent === '' ||
						!isValidFutureDate(publisDateEvent) ||
						expirationDateEvent === '' ||
						!isValidFutureDate(expirationDateEvent) ||
						!isValidEventEndDate(publisDateEvent, expirationDateEvent)
					) {
						setIsSubmit(false)
					} else {
						setIsSubmit(true)
					}
				} else if (endRadio.value === 'specific_day') {
					if (
						!isValidRecurrence() ||
						endDate === '' ||
						!isValidFutureDate(endDate) ||
						!isValidEndDateVsDataCurrency(dataCurrency, endDate) ||
						dataCurrency === '' ||
						!isValidFutureDate(dataCurrency) ||
						publisDateEvent === '' ||
						!isValidFutureDate(publisDateEvent) ||
						expirationDateEvent === '' ||
						!isValidFutureDate(expirationDateEvent) ||
						!isValidEventEndDate(publisDateEvent, expirationDateEvent)
					) {
						setIsSubmit(false)
					} else {
						setIsSubmit(true)
					}
				} else if (
					!isValidRecurrence() ||
					dataCurrency === '' ||
					!isValidFutureDate(dataCurrency) ||
					publisDateEvent === '' ||
					!isValidFutureDate(publisDateEvent) ||
					expirationDateEvent === '' ||
					!isValidFutureDate(expirationDateEvent) ||
					!isValidEventEndDate(publisDateEvent, expirationDateEvent)
				) {
					setIsSubmit(false)
				} else {
					setIsSubmit(true)
				}
			} else if (itemRecurrence === '2' && eventRecurrence === '2') {
				if (periodType.value === 'week') {
					if (
						!isValidRecurrence() ||
						dataCurrency === '' ||
						!isValidFutureDate(dataCurrency) ||
						listDaysSeleted.length === 0 ||
						publisDateEvent === '' ||
						!isValidFutureDate(publisDateEvent) ||
						expirationDateEvent === '' ||
						!isValidFutureDate(expirationDateEvent) ||
						!isValidEventEndDate(publisDateEvent, expirationDateEvent) ||
						untilDateEvent === '' ||
						!isValidFutureDate(untilDateEvent) ||
						!isValidUntilDate(expirationDateEvent, untilDateEvent)
					) {
						setIsSubmit(false)
					} else {
						setIsSubmit(true)
					}
				} else if (endRadio.value === 'specific_day') {
					if (
						!isValidRecurrence() ||
						endDate === '' ||
						!isValidFutureDate(endDate) ||
						!isValidEndDateVsDataCurrency(dataCurrency, endDate) ||
						dataCurrency === '' ||
						!isValidFutureDate(dataCurrency) ||
						publisDateEvent === '' ||
						!isValidFutureDate(publisDateEvent) ||
						expirationDateEvent === '' ||
						!isValidFutureDate(expirationDateEvent) ||
						!isValidEventEndDate(publisDateEvent, expirationDateEvent) ||
						untilDateEvent === '' ||
						!isValidFutureDate(untilDateEvent) ||
						!isValidUntilDate(expirationDateEvent, untilDateEvent)
					) {
						setIsSubmit(false)
					} else {
						setIsSubmit(true)
					}
				} else if (
					!isValidRecurrence() ||
					dataCurrency === '' ||
					!isValidFutureDate(dataCurrency) ||
					publisDateEvent === '' ||
					!isValidFutureDate(publisDateEvent) ||
					expirationDateEvent === '' ||
					!isValidFutureDate(expirationDateEvent) ||
					!isValidEventEndDate(publisDateEvent, expirationDateEvent) ||
					untilDateEvent === '' ||
					!isValidFutureDate(untilDateEvent) ||
					!isValidUntilDate(expirationDateEvent, untilDateEvent)
				) {
					setIsSubmit(false)
				} else {
					setIsSubmit(true)
				}
			} else if (itemRecurrence === '4') {
				if (eventRecurrence === '1') {
					if (
						publisDateEvent === '' ||
						!isValidFutureDate(publisDateEvent) ||
						expirationDateEvent === '' ||
						!isValidFutureDate(expirationDateEvent) ||
						!isValidEventEndDate(publisDateEvent, expirationDateEvent)
					) {
						setIsSubmit(false)
					} else {
						setIsSubmit(true)
					}
				} else if (eventRecurrence === '2') {
					if (
						publisDateEvent === '' ||
						!isValidFutureDate(publisDateEvent) ||
						expirationDateEvent === '' ||
						!isValidFutureDate(expirationDateEvent) ||
						!isValidEventEndDate(publisDateEvent, expirationDateEvent) ||
						untilDateEvent === '' ||
						!isValidFutureDate(untilDateEvent) ||
						!isValidUntilDate(expirationDateEvent, untilDateEvent)
					) {
						setIsSubmit(false)
					} else {
						setIsSubmit(true)
					}
				}
			}
		} else if (itemRecurrence === '1') {
			if (
				publisDate === '' ||
				!isValidFutureDate(publisDate) ||
				(isExpiratedView &&
					(expirationDate === '' ||
						!isValidFutureDate(expirationDate) ||
						!isValidExpirationDate(publisDate, expirationDate)))
			) {
				setIsSubmit(false)
			} else {
				setIsSubmit(true)
			}
		} else if (itemRecurrence === '2') {
			if (periodType.value === 'week') {
				if (
					!isValidRecurrence() ||
					listDaysSeleted.length === 0 ||
					dataCurrency === '' ||
					!isValidFutureDate(dataCurrency)
				) {
					setIsSubmit(false)
				} else {
					setIsSubmit(true)
				}
			} else if (endRadio.value === 'specific_day') {
				if (
					!isValidRecurrence() ||
					endDate === '' ||
					!isValidFutureDate(endDate) ||
					!isValidEndDateVsDataCurrency(dataCurrency, endDate) ||
					dataCurrency === '' ||
					!isValidFutureDate(dataCurrency)
				) {
					setIsSubmit(false)
				} else {
					setIsSubmit(true)
				}
			} else if (
				!isValidRecurrence() ||
				dataCurrency === '' ||
				!isValidFutureDate(dataCurrency)
			) {
				setIsSubmit(false)
			} else {
				setIsSubmit(true)
			}
		} else if (itemRecurrence === '3') {
			setIsSubmit(true)
		} else if (itemRecurrence === '4') {
			// For "Publish now", always enable the button for non-event categories
			setIsSubmit(true)
		}
	}, [
		endDate,
		endRadio,
		periodType,
		publisDate,
		dataCurrency,
		untilDateEvent,
		expirationDate,
		itemRecurrence,
		listDaysSeleted,
		publisDateEvent,
		eventRecurrence,
		expirationDateEvent,
		isExpiratedView,
		dateType,
		endDateType
	])

	const onSubmit: SubmitHandler<ScheduleFormInputs> = () => {
		setDeliveryActive({
			...deliveryActive,
			shedule:
				!(itemRecurrence === '3' || itemRecurrence === '4') ||
				totalData.basic_setup.category === 'event'
		})

		if (totalData.basic_setup.category === 'event' && itemRecurrence !== '3') {
			setTotalData({
				...totalData,
				delivery_enhancements: {
					...totalData.delivery_enhancements,
					is_perpetual: itemRecurrence === '4' || false,
					schedule: {
						...totalData.delivery_enhancements.schedule,
						timing: {
							release_date:
								itemRecurrence === '1'
									? dayjs(publisDate).utc().format('YYYY-MM-DDTHH:mm')
									: '',
							expiration_date:
								itemRecurrence === '1'
									? dayjs(isExpiratedView ? expirationDate : publisDate)
											.utc()
											.format('YYYY-MM-DDTHH:mm')
									: ''
						},
						custom_recurrence: {
							repeating_schedule: itemRecurrence === '2',
							repeat_start_date:
								itemRecurrence === '2'
									? dayjs(dataCurrency).utc().format('YYYY-MM-DDTHH:mm')
									: '',
							repeat_every_type:
								itemRecurrence === '2' ? (periodType.value as string) : '',
							repeat_every_value:
								itemRecurrence === '2' ? (dateType.id as number) : 1,
							repeat_on:
								itemRecurrence === '2'
									? `['${listDaysSeleted.join("','")}']`
									: '',
							ends: {
								repeat_end_value:
									itemRecurrence === '2' ? (endDateType.id as number) : 1,
								repeat_end_type: itemRecurrence === '2' ? endRadio.value : '',
								repeat_end_date:
									itemRecurrence === '2'
										? dayjs(endDate).utc().format('YYYY-MM-DDTHH:mm')
										: '',
								after_ocurrences:
									itemRecurrence === '2' ? (endDateType.id as number) : 1
							}
						},
						event: {
							...totalData.delivery_enhancements.schedule.event,
							event_start_date: dayjs(publisDateEvent)
								.utc()
								.format('YYYY-MM-DDTHH:mm'),
							event_end_date: dayjs(expirationDateEvent)
								.utc()
								.format('YYYY-MM-DDTHH:mm'),
							event_repeat_until:
								eventRecurrence === '2'
									? dayjs.utc(untilDateEvent).format('YYYY-MM-DDTHH:mm')
									: ''

							// custom_recurrence: {
							// 		.custom_recurrence,
							// 	repeating_schedule: eventRecurrence === '2'
							// Pendiente revicion con cliente
							// repeat_start_date:
							// 	dayjs(dataCurrencyEvent).format('YYYY-MM-DDTHH:mm'),
							// repeat_every_type: periodTypeEvent.value as string,
							// repeat_every_value: dateTypeEvent.id as number,
							// repeat_on: `['${listDaysSeletedEvent.join("','")}']`,
							// ends: {
							// 	repeat_end_type: endRadioEvent.value,
							// 	repeat_end_date:
							// 		endDateEvent !== ''
							// 			? dayjs(endDateEvent).format('YYYY-MM-DDTHH:mm')
							// 			: '',
							// 	after_ocurrences: endDdateTypeEvent.id as number
							// }
							// }
						}
					}
				},
				...(itemDatePushNotofication === '3' && {
					push_notification: {
						title: '',
						message: '',
						is_title: true,
						is_message: true,
						image: '',
						timing: { release_date: null },
						custom_recurrence: {
							repeating_schedule: false,
							repeat_start_date: null,
							repeat_every_type: null,
							repeat_every_value: 0,
							repeat_on: '',
							ends: {
								repeat_end_type: '',
								repeat_end_date: null,
								after_ocurrences: 0
							}
						}
					}
				})
			})
			if (itemDatePushNotofication === '3' && setItemDatePushNotofication) {
				setItemDatePushNotofication('4')
				setDeliveryActive({
					...deliveryActive,
					push_notification: false
				})
			}
			setOpenSlide(false)
		} else if (
			totalData.basic_setup.category !== 'event' &&
			itemRecurrence !== '3'
		) {
			setTotalData({
				...totalData,
				delivery_enhancements: {
					...totalData.delivery_enhancements,
					is_perpetual: false,
					schedule: {
						...totalData.delivery_enhancements.schedule,
						timing: {
							release_date:
								itemRecurrence === '1'
									? dayjs(publisDate).utc().format('YYYY-MM-DDTHH:mm')
									: '',
							expiration_date:
								itemRecurrence === '1'
									? dayjs(isExpiratedView ? expirationDate : publisDate)
											.utc()
											.format('YYYY-MM-DDTHH:mm')
									: ''
						},
						custom_recurrence: {
							repeating_schedule: itemRecurrence !== '1',
							repeat_start_date:
								itemRecurrence === '2'
									? dayjs(dataCurrency).utc().format('YYYY-MM-DDTHH:mm')
									: '',
							repeat_every_type:
								itemRecurrence === '2' ? (periodType.value as string) : '',
							repeat_every_value:
								itemRecurrence === '2' ? (dateType.id as number) : 0,
							repeat_on:
								itemRecurrence === '2'
									? `['${listDaysSeleted.join("','")}']`
									: '',
							ends: {
								// after_ocurrence , specific_day, never
								repeat_end_value:
									itemRecurrence === '2' ? (endDateType.id as number) : 0,
								repeat_end_type: itemRecurrence === '2' ? endRadio.value : '',
								repeat_end_date:
									itemRecurrence === '2'
										? endDate !== ''
											? dayjs(endDate).utc().format('YYYY-MM-DDTHH:mm')
											: ''
										: '',
								after_ocurrences:
									itemRecurrence === '2' && endRadio.value === 'never'
										? null
										: itemRecurrence === '2'
										? (endDateType.id as number)
										: 0
							}
						}
					}
				},
				...(itemDatePushNotofication === '3' && {
					push_notification: {
						title: '',
						message: '',
						is_title: true,
						is_message: true,
						image: '',
						timing: { release_date: null },
						custom_recurrence: {
							repeating_schedule: false,
							repeat_start_date: null,
							repeat_every_type: null,
							repeat_every_value: 0,
							repeat_on: '',
							ends: {
								repeat_end_type: '',
								repeat_end_date: null,
								after_ocurrences: 0
							}
						}
					}
				})
			})
			if (itemDatePushNotofication === '3' && setItemDatePushNotofication) {
				setItemDatePushNotofication('4')
				setDeliveryActive({
					...deliveryActive,
					push_notification: false
				})
			}
			setOpenSlide(false)
		} else if (itemRecurrence === '3') {
			setTotalData({
				...totalData,
				delivery_enhancements: {
					...totalData.delivery_enhancements,
					is_perpetual: true,
					schedule: {
						...totalData.delivery_enhancements.schedule,
						timing: {
							release_date: '',
							expiration_date: ''
						},
						custom_recurrence: {
							repeating_schedule: itemRecurrence !== '3',
							repeat_start_date: '',
							repeat_every_type: '',
							repeat_every_value: 0,
							repeat_on: '',
							ends: {
								repeat_end_value: 0,
								repeat_end_type: '',
								repeat_end_date: '',
								after_ocurrences: 0
							}
						}
					}
				}
			})
			setOpenSlide(false)
		}
		if (itemRecurrence.toString() === '4') {
			if (totalData.basic_setup.category !== 'event') {
				setTotalData({
					...totalData,
					delivery_enhancements: {
						...totalData.delivery_enhancements,
						is_perpetual: true,
						schedule: {
							...totalData.delivery_enhancements.schedule,
							timing: {
								release_date: '',
								expiration_date: ''
							},
							custom_recurrence: {
								repeating_schedule: false,
								repeat_start_date: '',
								repeat_every_type: '',
								repeat_every_value: 0,
								repeat_on: '',
								ends: {
									repeat_end_value: 0,
									repeat_end_type: '',
									repeat_end_date: '',
									after_ocurrences: 0
								}
							}
						}
					}
				})
			}
			onClickClose()
		}
	}

	useEffect(() => {
		if (
			(totalData?.delivery_enhancements?.schedule?.custom_recurrence &&
				totalData.delivery_enhancements.schedule.custom_recurrence
					.repeating_schedule === false) ||
			totalData?.delivery_enhancements?.schedule?.timing?.release_date
		) {
			if (
				(totalData.delivery_enhancements.is_perpetual || mode === 'create') &&
				!totalData.delivery_enhancements?.schedule?.timing.release_date
			) {
				setItemRecurrence('4')
			} else {
				setItemRecurrence('1')
			}
			setPublisDate(
				totalData.delivery_enhancements.schedule.timing.release_date !== ''
					? dayjs
							.utc(totalData.delivery_enhancements.schedule.timing.release_date)
							.local()
					: ''
			)
			if (isExpiratedView) {
				setExpirationDate(
					totalData.delivery_enhancements.schedule.timing.expiration_date !== ''
						? dayjs
								.utc(
									totalData.delivery_enhancements.schedule.timing
										.expiration_date
								)
								.local()
						: ''
				)
			}
		} else {
			setItemRecurrence('2')
			setDataCurrency(
				totalData.delivery_enhancements.schedule.custom_recurrence &&
					totalData.delivery_enhancements.schedule.custom_recurrence
						.repeat_start_date !== ''
					? dayjs
							.utc(
								totalData.delivery_enhancements.schedule.custom_recurrence
									.repeat_start_date
							)
							.local()
					: ''
			)
			const auxDay = daysTypeData?.find(item => {
				const schedule = totalData?.delivery_enhancements?.schedule
				const customRecurrence = schedule?.custom_recurrence

				return item.id === customRecurrence?.repeat_every_value
			})
			if (auxDay) {
				setDateType(auxDay)
			}
			const auxPeriod = periodTypeData.find(item => {
				const customRecurrence =
					totalData?.delivery_enhancements?.schedule?.custom_recurrence
				const repeatEveryType = customRecurrence?.repeat_every_type

				return item.value === repeatEveryType
			})
			if (auxPeriod) {
				setPeriodType(auxPeriod)
			}
			const repeatOn =
				totalData?.delivery_enhancements?.schedule?.custom_recurrence?.repeat_on

			if (repeatOn) {
				setListDaysSeleted(repeatOn.replace(/[\[\]']+/g, '').split(','))
			}
			const auxEndRadio = endShedules.find(item => {
				const customRecurrenceEnds =
					totalData?.delivery_enhancements?.schedule?.custom_recurrence?.ends
				const repeatEndType = customRecurrenceEnds?.repeat_end_type

				return item.value === repeatEndType
			})
			if (auxEndRadio) {
				setEndRadio(auxEndRadio)
			}
			const auxEndDateType = daysTypeData.find(item => {
				const customRecurrence =
					totalData?.delivery_enhancements?.schedule?.custom_recurrence
				const repeatEveryValue = customRecurrence?.repeat_every_value

				return item.id === repeatEveryValue
			})
			if (auxEndDateType) {
				setEndDateType(auxEndDateType)
			}
			const customRecurrenceEnds =
				totalData?.delivery_enhancements?.schedule?.custom_recurrence?.ends
			if (customRecurrenceEnds) {
				setEndDate(
					totalData?.delivery_enhancements?.schedule?.custom_recurrence?.ends
						?.repeat_end_type === 'specific_day' &&
						totalData?.delivery_enhancements?.schedule?.custom_recurrence?.ends
							?.repeat_end_date !== ''
						? dayjs
								.utc(
									totalData.delivery_enhancements.schedule.custom_recurrence
										.ends.repeat_end_date
								)
								.local()
						: ''
				)
			}
		}
		if (totalData.basic_setup.category === 'event') {
			if (
				totalData.delivery_enhancements.schedule.event.event_repeat_until === ''
			) {
				setEventRecurrence('1')
				setPublisDateEvent(
					totalData.delivery_enhancements.schedule.event.event_start_date !== ''
						? dayjs
								.utc(
									totalData.delivery_enhancements.schedule.event
										.event_start_date
								)
								.local()
						: ''
				)
				setExpirationDateEvent(
					totalData.delivery_enhancements.schedule.event.event_end_date !== ''
						? dayjs
								.utc(
									totalData.delivery_enhancements.schedule.event.event_end_date
								)
								.local()
						: ''
				)
			} else {
				setEventRecurrence('2')
				setPublisDateEvent(
					totalData.delivery_enhancements.schedule.event.event_start_date !== ''
						? dayjs
								.utc(
									totalData.delivery_enhancements.schedule.event
										.event_start_date
								)
								.local()
						: ''
				)
				setExpirationDateEvent(
					totalData.delivery_enhancements.schedule.event.event_end_date !== ''
						? dayjs
								.utc(
									totalData.delivery_enhancements.schedule.event.event_end_date
								)
								.local()
						: ''
				)
				setUntilDateEvent(
					totalData.delivery_enhancements.schedule.event.event_repeat_until !==
						''
						? dayjs
								.utc(
									totalData.delivery_enhancements.schedule.event
										.event_repeat_until
								)
								.local()
						: ''
				)
				// setDataCurrencyEvent(
				// 	totalData.delivery_enhancements.schedule.event.custom_recurrence
				// 		.repeat_start_date !== ''
				// 		? dayjs(
				// 				totalData.delivery_enhancements.schedule.event.custom_recurrence
				// 					.repeat_start_date
				// 		  ).format('MM/DD/YYYY HH:mm')
				// 		: ''
				// )
				// const auxDayEvent = daysTypeData.find(
				// 	item =>
				// 		item.id ===
				// 		totalData.delivery_enhancements.schedule.event.custom_recurrence
				// 			.repeat_every_value
				// )
				// if (auxDayEvent) {
				// 	setDateType(auxDayEvent)
				// }
				// const auxPeriodEvnet = periodTypeData.find(
				// 	item =>
				// 		item.value ===
				// 		totalData.delivery_enhancements.schedule.event.custom_recurrence
				// 			.repeat_every_type
				// )
				// if (auxPeriodEvnet) {
				// 	setPeriodTypeEvent(auxPeriodEvnet)
				// }
				// const auxDateEvnet = daysTypeData.find(
				// 	item =>
				// 		item.id ===
				// 		totalData.delivery_enhancements.schedule.event.custom_recurrence
				// 			.repeat_every_value
				// )
				// if (auxDateEvnet) {
				// 	setEndDateTypeEvent(auxDateEvnet)
				// }
				// setListDaysSeletedEvent(
				// 	totalData.delivery_enhancements.schedule.event.custom_recurrence.repeat_on
				// 		.replace(/[\[\]']+/g, '')
				// 		.split(',')
				// )
			}
		}
		setEdit(prev => prev + 1)
	}, [totalData])

	useEffect(() => {
		const repeatingSchedule =
			totalData?.delivery_enhancements?.schedule?.custom_recurrence
				?.repeating_schedule
		const releaseDate =
			totalData?.delivery_enhancements?.schedule?.timing?.release_date

		const itemsToRender =
			(mode === 'create' || mode === 'edit') &&
			(repeatingSchedule !== false || releaseDate !== '')
				? itemScheduleEdit
				: itemSchedule

		setItemSelected(itemsToRender)
	}, [totalData, mode, itemSchedule, itemScheduleEdit])

	useEffect(() => {
		if (totalData.basic_setup.category !== 'event') return
		if (itemRecurrence !== '1') return
		if (totalData.delivery_enhancements.schedule.event.event_start_date !== '')
			return
		if (publisDate) {
			setPublisDateEvent(publisDate)
		}
		if (expirationDate) {
			setExpirationDateEvent(expirationDate)
		} else if (publisDate) {
			setExpirationDateEvent(dayjs(publisDate as Dayjs).add(1, 'day'))
		}
		setEventDateResetKey(prev => prev + 1)
	}, [
		itemRecurrence,
		publisDate,
		expirationDate,
		totalData.basic_setup.category
	])

	const handleChangeDateEvent = (
		stateDateEvent: SetStateAction<string | Dayjs>
	): void => {
		setPublisDateEvent(stateDateEvent)
		if (
			(expirationDateEvent &&
				dayjs(expirationDateEvent).isBefore(stateDateEvent as Dayjs)) ||
			dayjs(expirationDateEvent as Dayjs).isSame(stateDateEvent as Dayjs)
		) {
			showToastDebounced(
				'Error',
				'Oops! The end date cannot be set up before the start date. Please select a later date.',
				'error'
			)
		} else if (
			itemRecurrence === '1' &&
			publisDate &&
			dayjs(stateDateEvent as Dayjs).isBefore(
				dayjs(publisDate as Dayjs),
				'minute'
			)
		) {
			showToastDebounced(
				'Error',
				'Oops! The event start date cannot be before the content publish date.',
				'error'
			)
		} else if (
			itemRecurrence === '1' &&
			expirationDate &&
			dayjs(stateDateEvent as Dayjs).isAfter(
				dayjs(expirationDate as Dayjs),
				'minute'
			)
		) {
			showToastDebounced(
				'Error',
				'Oops! The event start date cannot be after the content expiration date.',
				'error'
			)
		} else {
			showToastDebounced.cancel()
		}
	}

	const handleChangeDateEventEnds = (
		valueEnds: SetStateAction<string | Dayjs>
	): void => {
		if (
			(valueEnds && dayjs(valueEnds as Dayjs).isBefore(publisDateEvent)) ||
			dayjs(valueEnds as Dayjs).isSame(publisDateEvent)
		) {
			showToastDebounced(
				'Error',
				'Oops! The end date cannot be set up before the start date. Please select a later date.',
				'error'
			)
		} else if (
			itemRecurrence === '1' &&
			isExpiratedView &&
			expirationDate &&
			dayjs(valueEnds as Dayjs).isAfter(
				dayjs(expirationDate as Dayjs),
				'minute'
			)
		) {
			showToastDebounced(
				'Error',
				'Oops! The event end date cannot be after the content expiration date.',
				'error'
			)
		} else {
			showToastDebounced.cancel()
		}

		setExpirationDateEvent(valueEnds)
	}

	return (
		<div>
			{isLoading ? (
				<div className="flex items-center justify-center w-full h-[400px] py-2 px-1 ">
					<CircularProgress disableShrink />
				</div>
			) : (
				<form
					key={edit}
					onSubmit={handleSubmit(onSubmit)}
					className="mt-5 flex flex-col justify-between h-full"
				>
					<div>
						<div className="mb-2">
							<div>
								{itemSelected.map(item => {
									const element = {
										...item,
										title: `${locationComponent} ${item.title}`
									}
									const typeSchedule = item.id === '1' || item.id === '2'
									return (
										<InputRadio
											item={typeSchedule ? element : item}
											key={item.id}
											defaultChecked={itemRecurrence}
											setItemRecurrence={setItemRecurrence}
										/>
									)
								})}
							</div>

							{itemRecurrence === '1' ? (
								<div key={itemRecurrence}>
									<DateTimer
										className="mt-2"
										validate={dayjs().format('MM/DD/YYYY HH:mm')}
										icon={Icons.calendar}
										setDate={handleChangeSchedule}
										initialValue={publisDate}
										title="Publish date and time"
										placeholderInput={
											!publisDate
												? dayjs().add(5, 'minutes').format('MM/DD/YYYY hh:mm A')
												: ''
										}
										helper
										textHelper="Time and date reflects your local time."
										autoInitialize
									/>
									{isExpiratedView && (
										<DateTimer
											className="mt-2"
											icon={Icons.calendar}
											setDate={handleChangeExpirationDate}
											validate={dayjs().format('MM/DD/YYYY HH:mm')}
											initialValue={expirationDate}
											title="Expiration date and time:"
											placeholderInput={
												!expirationDate
													? dayjs()
															.add(5, 'minutes')
															.format('MM/DD/YYYY hh:mm A')
													: ''
											}
											autoInitialize
										/>
									)}
								</div>
							) : itemRecurrence === '2' ? (
								<div key={itemRecurrence}>
									<div className="w-full flex justify-between items-center mb-2">
										<Typography
											className="text-lavender"
											type={TypographyTypes.span}
											fontLeading="10/12"
											title="Set to automatically refresh publish date and time."
										/>
										<Helper text="Time and date reflects your local time." />
									</div>
									<DateTimer
										line={false}
										className="mt-2"
										setDate={handleChangeDataCurrency}
										icon={Icons.calendarCheck}
										initialValue={dataCurrency}
										validate={dayjs().format('MM/DD/YYYY HH:mm')}
										placeholderInput={
											!dataCurrency
												? dayjs().add(5, 'minutes').format('MM/DD/YYYY hh:mm A')
												: ''
										}
										autoInitialize
									/>
									<div className="flex items-center gap-2 mt-2">
										<Typography
											title="Repeat every"
											type={TypographyTypes.span}
											fontLeading="15/18"
										/>
										<DropdownFull
											item={dateType}
											list={daysTypeData}
											setItem={setDateType}
											className="w-[120px] sm:w-[140px]"
										/>
										<DropdownFull
											item={periodType}
											list={periodTypeData}
											setItem={setPeriodType}
											className="w-[120px] sm:w-[140px]"
										/>
									</div>
									{periodType.value === 'week' && (
										<div className="my-2">
											<Typography
												title="Repeat On"
												type={TypographyTypes.span}
												fontLeading="15/18"
												className="mb-3"
											/>
											<BarMultiSelect
												list={listDays}
												listSeleted={listDaysSeleted}
												setListSeleted={setListDaysSeleted}
											/>
										</div>
									)}
									<RadioGroups
										name="ends"
										title="Ends"
										checked={endRadio}
										options={endShedules}
										setEndDate={handleChangeEndDate}
										setChecked={setEndRadio}
										endDate={endDate}
										endDdateType={endDateType}
										setEndDateType={setEndDateType}
										validate={dayjs().format('MM/DD/YYYY HH:mm')}
									/>
								</div>
							) : (
								''
							)}
						</div>
						{totalData.basic_setup.category === 'event' &&
							itemRecurrence !== '3' && (
								<div>
									<div className="mt-2">
										<Typography
											title="Events"
											type={TypographyTypes.h3}
											className="text-lavender mb-2"
											fontLeading="18/21"
										/>
										<Typography
											type={TypographyTypes.h3}
											className="text-lavender mb-2"
											fontLeading="10/12"
											title="Is this an event with dates and times? "
										/>
									</div>
									<div className="mb-2">
										<div>
											{itemScheduleEvent.map(item => (
												<InputRadio
													item={item}
													key={item.id}
													defaultChecked={eventRecurrence}
													setItemRecurrence={setEventRecurrence}
												/>
											))}
										</div>
										<DateTimer
											key={`event-start-${eventDateResetKey}`}
											className="mt-2"
											icon={Icons.calendar}
											title="Event date and time"
											setDate={handleChangeDateEvent}
											initialValue={publisDateEvent}
											validate={
												itemRecurrence === '1' && publisDate
													? publisDate
													: dayjs().format('MM/DD/YYYY HH:mm')
											}
											validateMax={
												itemRecurrence === '1' && expirationDate
													? expirationDate
													: undefined
											}
											placeholderInput={
												!publisDateEvent
													? dayjs()
															.add(5, 'minutes')
															.format('MM/DD/YYYY hh:mm A')
													: ''
											}
											autoInitialize
										/>
										<DateTimer
											key={`event-end-${eventDateResetKey}`}
											className="mt-2"
											icon={Icons.calendar}
											title="Event Ends at:"
											setDate={handleChangeDateEventEnds}
											initialValue={expirationDateEvent}
											validate={dayjs(publisDateEvent).format(
												'MM/DD/YYYY HH:mm'
											)}
											validateMax={
												itemRecurrence === '1' && expirationDate
													? expirationDate
													: undefined
											}
											placeholderInput={
												!expirationDateEvent
													? dayjs()
															.add(5, 'minutes')
															.format('MM/DD/YYYY hh:mm A')
													: ''
											}
											autoInitialize
										/>
										{eventRecurrence === '2' && (
											<DateTimer
												className="mt-2"
												icon={Icons.calendar}
												setDate={handleChangeUntilDateEvent}
												initialValue={untilDateEvent}
												title="This event repeats every day until:"
												validate={dayjs(expirationDateEvent).format(
													'MM/DD/YYYY HH:mm'
												)}
												placeholderInput={
													!untilDateEvent
														? dayjs()
																.add(5, 'minutes')
																.format('MM/DD/YYYY hh:mm A')
														: ''
												}
												autoInitialize
											/>
										)}
										{/* 
							Pendiente revision con cliente
							(
								<div>
									<Typography
										className="text-lavender"
										type={TypographyTypes.span}
										fontLeading={'10/12'}
										title="Set to automatically refresh publish date and time."
									/>
									<DateTimer
										line={false}
										className="mt-2"
										icon={Icons.calendarCheck}
										setDate={setDataCurrencyEvent}
										initialValue={dayjs(dataCurrencyEvent)}
										validate={dayjs().format('MM/DD/YYYY HH:mm')}
									/>
									<div className="flex items-center gap-2 mt-2">
										<Typography
											title="Repeat every"
											type={TypographyTypes.span}
											fontLeading={'15/18'}
										/>
										<DropdownFull
											item={dateTypeEvent}
											list={daysTypeData}
											setItem={setDateTypeEvent}
											className="min-w-[140px]"
										/>
										<DropdownFull
											item={periodTypeEvent}
											list={periodTypeData}
											setItem={setPeriodTypeEvent}
											className="min-w-[140px]"
										/>
									</div>
									{periodTypeEvent.value === 'week' && (
										<div className="mt-2">
											<Typography
												title="Repeat On"
												type={TypographyTypes.span}
												fontLeading={'15/18'}
												className="mb-2"
											/>
											<BarMultiSelect
												list={listDays}
												listSeleted={listDaysSeletedEvent}
												setListSeleted={setListDaysSeletedEvent}
											/>
										</div>
									)}
									<RadioGroups
										title="Ends"
										name="endsEvents"
										validate={dayjs().format('MM/DD/YYYY HH:mm')}
										options={endShedules}
										endDate={dayjs(endDateEvent)}
										checked={endRadioEvent}
										setEndDate={setEndDateEvent}
										setChecked={setEndRadioEvent}
										endDdateType={endDdateTypeEvent}
										setEndDateType={setEndDateTypeEvent}
									/>
								</div>
							)} */}
									</div>
								</div>
							)}
					</div>

					<div className="flex items-center justify-between">
						<Button
							type="button"
							label="Cancel"
							color="Transparent"
							className="!min-w-[130px]"
							onClick={onClickClose}
						/>
						<Button
							label="Save"
							type="submit"
							color="Primary"
							className="!min-w-[130px]"
							disabled={!isSubmit}
						/>
					</div>
				</form>
			)}
		</div>
	)
}
